import { render, staticRenderFns } from "./HonorariosAcaoJudicial.vue?vue&type=template&id=e123af3a&"
import script from "./HonorariosAcaoJudicial.vue?vue&type=script&lang=js&"
export * from "./HonorariosAcaoJudicial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports